import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Stack from '@mui/material/Stack';
import { useButton } from '@mui/base/ButtonUnstyled';
import { styled } from '@mui/system';

const TargetingButtonRoot = styled('button')`
  background-color: #11254F;
  padding: 10px 10px;
  border-radius: 3px;
  color: #fff;
  font-weight: 400;
  font-family: inherit;
  font-size: 12px;
  transition: all 200ms ease;
  cursor: pointer;
 /* box-shadow: 0 4px 20px 0 rgba(61, 71, 82, 0.1), 0 0 0 0 rgba(0, 127, 255, 0); */
  border: 1px solid #fff;

  &:hover {
    background-color: #11254F;
    opacity: 0.6;
  }

  &.active {
    background-color: #11254F;
    opacity: 0.6;
  }

`;


const TargetingButton = React.forwardRef(function TargetingButton(props, ref) {
    const { children } = props;
    const { active, focusVisible, getRootProps } = useButton({
      ...props,
      ref,
      component: TargetingButtonRoot,
    });

    const classes = {
      active,
      focusVisible,
    };

    return (
      <TargetingButtonRoot {...getRootProps()} className={clsx(classes)}>
        {children}
      </TargetingButtonRoot>
    );
  });

  TargetingButton.propTypes = {
    children: PropTypes.node,
  };

export default function TargetingButtons() {
  return (
    <Stack
        direction="row"
        spacing={2}
        >
      <TargetingButton href="#targeting-button">TARGETING</TargetingButton>
    </Stack>
  );
}